import BusinessError from '../util/BusinessError';
import { SITUACAO_CERTIDAO } from './SituacaoCertidao';
import SituacaoJulgamentoProcessoBusiness from './SituacaoJulgamentoProcessoBusiness';

/**
 * @classdesc Agrega as regras semânticas relacionadas às situações de certidão de julgamento.
 * @readonly
 */
export default class SituacaoCertidaoJulgamentoBusiness {
    static MSG_ERRO_IDENTIFICACAO_SITUACAO_CERTIDAO =
        'Não foi possível identificar a situação do certidão para o fuxo de assinatura/publicação.';
    static MSG_ERRO_IDENTIFICACAO_SITUACAO_CERTIDAO_PROCESSO_NAO_APRECIADO =
        'As situações de certidão de julgamento para processos não apreciados são ignoradas.';

    static getSituacaoCertidaoJulgamento(registro) {
        if (!SituacaoJulgamentoProcessoBusiness.isProcessoApreciado(registro?.resultadoJulgamento)) {
            throw new BusinessError(
                `${SituacaoCertidaoJulgamentoBusiness.MSG_ERRO_IDENTIFICACAO_SITUACAO_CERTIDAO_PROCESSO_NAO_APRECIADO} [${registro.numeroProcesso}]`
            );
        }

        if (SituacaoCertidaoJulgamentoBusiness.isCertidaoAssinada(registro)) {
            return SITUACAO_CERTIDAO.ASSINADA;
        }

        if (SituacaoCertidaoJulgamentoBusiness.isCertidaoNaoAssinada(registro)) {
            return SITUACAO_CERTIDAO.NAO_ASSINADA;
        }

        if (SituacaoCertidaoJulgamentoBusiness.isCertidaoNaoCriada(registro)) {
            return SITUACAO_CERTIDAO.NAO_CRIADA;
        }

        throw new BusinessError(
            `${SituacaoCertidaoJulgamentoBusiness.MSG_ERRO_IDENTIFICACAO_SITUACAO_CERTIDAO} [${registro.numeroProcesso}]`
        );
    }

    static isCertidaoNaoCriada(registro) {
        return !registro.certidaoGerada;
    }

    static isCertidaoNaoAssinada(registro) {
        return registro.certidaoGerada && !registro.certidaoJulgamentoAssinada;
    }

    static isCertidaoAssinada(registro) {
        return registro.certidaoJulgamentoAssinada;
    }
}
